/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { BaseResponse } from '../models/base-response';
import { ticketStatusControllerCreate } from '../fn/ticket-status/ticket-status-controller-create';
import { TicketStatusControllerCreate$Params } from '../fn/ticket-status/ticket-status-controller-create';
import { ticketStatusControllerDeleteEmailConfiguration } from '../fn/ticket-status/ticket-status-controller-delete-email-configuration';
import { TicketStatusControllerDeleteEmailConfiguration$Params } from '../fn/ticket-status/ticket-status-controller-delete-email-configuration';
import { ticketStatusControllerFindAll } from '../fn/ticket-status/ticket-status-controller-find-all';
import { TicketStatusControllerFindAll$Params } from '../fn/ticket-status/ticket-status-controller-find-all';
import { ticketStatusControllerFindOne } from '../fn/ticket-status/ticket-status-controller-find-one';
import { TicketStatusControllerFindOne$Params } from '../fn/ticket-status/ticket-status-controller-find-one';
import { ticketStatusControllerGetEmailConfiguration } from '../fn/ticket-status/ticket-status-controller-get-email-configuration';
import { TicketStatusControllerGetEmailConfiguration$Params } from '../fn/ticket-status/ticket-status-controller-get-email-configuration';
import { ticketStatusControllerRemove } from '../fn/ticket-status/ticket-status-controller-remove';
import { TicketStatusControllerRemove$Params } from '../fn/ticket-status/ticket-status-controller-remove';
import { ticketStatusControllerSetEmailConfiguration } from '../fn/ticket-status/ticket-status-controller-set-email-configuration';
import { TicketStatusControllerSetEmailConfiguration$Params } from '../fn/ticket-status/ticket-status-controller-set-email-configuration';
import { ticketStatusControllerUpdate } from '../fn/ticket-status/ticket-status-controller-update';
import { TicketStatusControllerUpdate$Params } from '../fn/ticket-status/ticket-status-controller-update';
import { TicketStatusPaginatedResponseItem } from '../models/ticket-status-paginated-response-item';
import { TicketStatusResponseItem } from '../models/ticket-status-response-item';

@Injectable({ providedIn: 'root' })
export class TicketStatusService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `ticketStatusControllerFindAll()` */
  static readonly TicketStatusControllerFindAllPath = '/ticket-status';

  /**
   * Get all ticket statuses with pagination.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ticketStatusControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  ticketStatusControllerFindAll$Response(params: TicketStatusControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: TicketStatusPaginatedResponseItem;
}>> {
    return ticketStatusControllerFindAll(this.http, this.rootUrl, params, context);
  }

  /**
   * Get all ticket statuses with pagination.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ticketStatusControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ticketStatusControllerFindAll(params: TicketStatusControllerFindAll$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: TicketStatusPaginatedResponseItem;
}> {
    return this.ticketStatusControllerFindAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: TicketStatusPaginatedResponseItem;
}>): BaseResponse & {
'data'?: TicketStatusPaginatedResponseItem;
} => r.body)
    );
  }

  /** Path part for operation `ticketStatusControllerCreate()` */
  static readonly TicketStatusControllerCreatePath = '/ticket-status';

  /**
   * Create a new ticket status.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ticketStatusControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ticketStatusControllerCreate$Response(params: TicketStatusControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: TicketStatusResponseItem;
}>> {
    return ticketStatusControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Create a new ticket status.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ticketStatusControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ticketStatusControllerCreate(params: TicketStatusControllerCreate$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: TicketStatusResponseItem;
}> {
    return this.ticketStatusControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: TicketStatusResponseItem;
}>): BaseResponse & {
'data'?: TicketStatusResponseItem;
} => r.body)
    );
  }

  /** Path part for operation `ticketStatusControllerFindOne()` */
  static readonly TicketStatusControllerFindOnePath = '/ticket-status/{id}';

  /**
   * Get a ticket status by ID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ticketStatusControllerFindOne()` instead.
   *
   * This method doesn't expect any request body.
   */
  ticketStatusControllerFindOne$Response(params: TicketStatusControllerFindOne$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: TicketStatusResponseItem;
}>> {
    return ticketStatusControllerFindOne(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a ticket status by ID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ticketStatusControllerFindOne$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ticketStatusControllerFindOne(params: TicketStatusControllerFindOne$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: TicketStatusResponseItem;
}> {
    return this.ticketStatusControllerFindOne$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: TicketStatusResponseItem;
}>): BaseResponse & {
'data'?: TicketStatusResponseItem;
} => r.body)
    );
  }

  /** Path part for operation `ticketStatusControllerUpdate()` */
  static readonly TicketStatusControllerUpdatePath = '/ticket-status/{id}';

  /**
   * Update a ticket status.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ticketStatusControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ticketStatusControllerUpdate$Response(params: TicketStatusControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: TicketStatusResponseItem;
}>> {
    return ticketStatusControllerUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Update a ticket status.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ticketStatusControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ticketStatusControllerUpdate(params: TicketStatusControllerUpdate$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: TicketStatusResponseItem;
}> {
    return this.ticketStatusControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: TicketStatusResponseItem;
}>): BaseResponse & {
'data'?: TicketStatusResponseItem;
} => r.body)
    );
  }

  /** Path part for operation `ticketStatusControllerRemove()` */
  static readonly TicketStatusControllerRemovePath = '/ticket-status/{id}';

  /**
   * Delete a ticket status.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ticketStatusControllerRemove()` instead.
   *
   * This method doesn't expect any request body.
   */
  ticketStatusControllerRemove$Response(params: TicketStatusControllerRemove$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: TicketStatusResponseItem;
}>> {
    return ticketStatusControllerRemove(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete a ticket status.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ticketStatusControllerRemove$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ticketStatusControllerRemove(params: TicketStatusControllerRemove$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: TicketStatusResponseItem;
}> {
    return this.ticketStatusControllerRemove$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: TicketStatusResponseItem;
}>): BaseResponse & {
'data'?: TicketStatusResponseItem;
} => r.body)
    );
  }

  /** Path part for operation `ticketStatusControllerGetEmailConfiguration()` */
  static readonly TicketStatusControllerGetEmailConfigurationPath = '/ticket-status/{id}/email-configuration';

  /**
   * Recupera la configurazione email di uno stato ticket.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ticketStatusControllerGetEmailConfiguration()` instead.
   *
   * This method doesn't expect any request body.
   */
  ticketStatusControllerGetEmailConfiguration$Response(params: TicketStatusControllerGetEmailConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return ticketStatusControllerGetEmailConfiguration(this.http, this.rootUrl, params, context);
  }

  /**
   * Recupera la configurazione email di uno stato ticket.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ticketStatusControllerGetEmailConfiguration$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ticketStatusControllerGetEmailConfiguration(params: TicketStatusControllerGetEmailConfiguration$Params, context?: HttpContext): Observable<void> {
    return this.ticketStatusControllerGetEmailConfiguration$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `ticketStatusControllerSetEmailConfiguration()` */
  static readonly TicketStatusControllerSetEmailConfigurationPath = '/ticket-status/{id}/email-configuration';

  /**
   * Imposta la configurazione email per uno stato ticket.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ticketStatusControllerSetEmailConfiguration()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ticketStatusControllerSetEmailConfiguration$Response(params: TicketStatusControllerSetEmailConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return ticketStatusControllerSetEmailConfiguration(this.http, this.rootUrl, params, context);
  }

  /**
   * Imposta la configurazione email per uno stato ticket.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ticketStatusControllerSetEmailConfiguration$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ticketStatusControllerSetEmailConfiguration(params: TicketStatusControllerSetEmailConfiguration$Params, context?: HttpContext): Observable<void> {
    return this.ticketStatusControllerSetEmailConfiguration$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `ticketStatusControllerDeleteEmailConfiguration()` */
  static readonly TicketStatusControllerDeleteEmailConfigurationPath = '/ticket-status/{id}/email-configuration';

  /**
   * Rimuove la configurazione email di uno stato ticket.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ticketStatusControllerDeleteEmailConfiguration()` instead.
   *
   * This method doesn't expect any request body.
   */
  ticketStatusControllerDeleteEmailConfiguration$Response(params: TicketStatusControllerDeleteEmailConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return ticketStatusControllerDeleteEmailConfiguration(this.http, this.rootUrl, params, context);
  }

  /**
   * Rimuove la configurazione email di uno stato ticket.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ticketStatusControllerDeleteEmailConfiguration$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ticketStatusControllerDeleteEmailConfiguration(params: TicketStatusControllerDeleteEmailConfiguration$Params, context?: HttpContext): Observable<void> {
    return this.ticketStatusControllerDeleteEmailConfiguration$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
